import React from "react"
import { SearchTicket} from "../../components"

const TicketSearch = () =>{
    return(
        <SearchTicket/>
    )
}

export default TicketSearch